<template>
    <div class="container">
        <backhome></backhome>
        <div style="height:90px;"></div>
        <div class="today">
            <h3 class="title">今日流量</h3>
            <table>
                <tbody>
                    <tr>
                        <td></td>
                        <td class="border"> 浏览量(PV)</td>
                        <td>访客数(UV)</td>
                    </tr>
                    <tr>
                        <td>今日</td>
                        <td class="border"><span class="text1">{{PV}}</span> </td>
                        <td><span class="text1">{{UV}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="bottom">
            <h3 class="title">新老访客</h3>
            <table>
                <thead>
                    <tr>
                        <th>
                            <img class="shenfen" src="../assets/shenfen.png" alt="">
                        </th>
                        <th class="border">新访客<br>
                            <span class="text2 bgG">{{n_ratio}}</span><span class="bgG">%</span>
                        </th>
                        <th>老访客<br>
                            <span class="text2 bgB">{{o_ratio}}</span><span class="bgB">%</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>浏览量</td>
                        <td>{{n_pv_count}}</td>
                        <td>{{o_pv_count}}</td>
                    </tr>
                    <tr>
                        <td>访客数</td>
                        <td>{{n_visitor_count}}</td>
                        <td>{{o_visitor_count}}</td>
                    </tr>
                    <tr>
                        <td>跳出率</td>
                        <td>{{n_bounce_ratio}}%</td>
                        <td>{{o_bounce_ratio}}%</td>
                    </tr>
                    <tr>
                        <td>平均访问时长</td>
                        <td>{{n_avg_visit_time | time}}</td>
                        <td>{{o_avg_visit_time | time}}</td>
                    </tr>
                    <tr>
                        <td>平均访问页数</td>
                        <td>{{n_avg_visit_pages}}</td>
                        <td>{{o_avg_visit_pages}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import https from '../https.js' 　
import { Indicator } from 'mint-ui';
import backhome from './common/backHome'
export default {
  data () {
    return {
        n_ratio:0,
        n_pv_count:0,
        n_visitor_count:0,
        n_bounce_ratio:0,
        n_avg_visit_time:0,
        n_avg_visit_pages:0,

        o_ratio:0,
        o_pv_count:0,
        o_visitor_count:0,
        o_bounce_ratio:0,
        o_avg_visit_time:0,
        o_avg_visit_pages:0,
        
    }
  },
  created(){
      this.getMsg();
  },
  mounted () {
        
  },
  methods:{
       getMsg(){
            Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                });
             https.fetchPost("Article/getBaiduTongjiData",{})
                  .then(result=>{
                      var newVisitor= this.newVisitor=result.data.data.body.data[0].result.visitType.newVisitor;
                      var oldVisitor= this.oldVisitor=result.data.data.body.data[0].result.visitType.oldVisitor;
                      this.n_ratio=newVisitor.ratio;
                      this.n_pv_count=newVisitor.pv_count;
                      this.n_visitor_count=newVisitor.visitor_count;
                      this.n_bounce_ratio=newVisitor.bounce_ratio;
                      this.n_avg_visit_time=newVisitor.avg_visit_time;
                      this.n_avg_visit_pages=newVisitor.avg_visit_pages;

                      this.o_ratio=oldVisitor.ratio;
                      this.o_pv_count=oldVisitor.pv_count;
                      this.o_visitor_count=oldVisitor.visitor_count;
                      this.o_bounce_ratio=oldVisitor.bounce_ratio;
                      this.o_avg_visit_time=oldVisitor.avg_visit_time;
                      this.o_avg_visit_pages=oldVisitor.avg_visit_pages;
                  })  
          },
  },
  components: {
      "backhome":backhome
  },
  computed:{
        //今日
      PV(){
          if(this.n_pv_count=="--"){
              this.n_pv_count=0;
          }
          if(this.o_pv_count=="--"){
              this.o_pv_count
          }
          return this.n_pv_count+this.o_pv_count;
      },
      UV(){
           if(this.n_visitor_count=="--"){
              this.n_visitor_count=0;
          }
          if(this.o_visitor_count=="--"){
              this.o_visitor_count=0
          }
          return this.n_visitor_count+this.o_visitor_count;
      }
  },
  filters:{
      time(value){
          if(value=="--"){
              return "00:00:00"
          }else{
                let result = parseInt(value)
        　　    let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
        　　    let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
        　　    let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
        　　    result = `${h}:${m}:${s}`
        　　    return result
          }
        }
  },
  watch:{
    PV(){
        Indicator.close();

    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
    height:99vh;
}
    table{
        width:100%;
        border-collapse: collapse;
    }
    td{
        width:33%;
        height:40px;
    }
    .title{
        text-align: left;
    }
    .today{
        margin:0 auto;
        /* width: 90%; */
        background:fff;
        padding: 10px;

    }
    .border{
        border-left:1px solid #ededef;
        border-right:1px solid #ededef;
    }
    .text1{
        font-size:20px;
        font-weight: 600;
    }
    .bottom{
         background:fff;
        margin-top:20px;
        padding: 10px;
    }
    .bottom>table>tbody>tr>td{
        border:1px solid #ededef;
    }
    .text2{
        font-size:28px;
        font-weight: 600;
    }
    .bgG{
        color:#48cb6d;
    }
    .bgB{
        color:#51a8f9;;
    }
    .shenfen{
        width: 70px;
    }
</style>



// WEBPACK FOOTER //
// src/components/baobiao.vue